var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBotIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.027,
    y1: 0.791,
    x2: 0.873,
    y2: 0.796,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf4fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#dde1e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_647",
    "data-name": "Groupe 647",
    transform: "translate(-2396 2069)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 36,
    cy: 36,
    r: 36,
    transform: "translate(2396 -2069)",
    fill: "#7e00d3",
    opacity: 0.301
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 27,
    cy: 27,
    r: 27,
    transform: "translate(2405 -2060)",
    fill: "#7e00d3",
    opacity: 0.735
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_140",
    "data-name": "Groupe 140",
    transform: "translate(2405.352 -2036.808)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_139",
    "data-name": "Groupe 139",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_191",
    "data-name": "Trac\\xE9 191",
    d: "M4.286,0C6.652,0,8.572,2.592,8.572,5.784s-1.921,5.784-4.286,5.784S0,8.976,0,5.784,1.921,0,4.286,0Z",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_192",
    "data-name": "Trac\\xE9 192",
    d: "M4.286,0C6.652,0,8.572,2.592,8.572,5.784s-1.921,5.784-4.286,5.784S0,8.976,0,5.784,1.921,0,4.286,0Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_142",
    "data-name": "Groupe 142",
    transform: "translate(2449.296 -2036.809)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_141",
    "data-name": "Groupe 141",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_193",
    "data-name": "Trac\\xE9 193",
    d: "M4.286,0C6.652,0,8.572,2.592,8.572,5.784s-1.921,5.784-4.286,5.784S0,8.976,0,5.784,1.921,0,4.286,0Z",
    transform: "translate(0 0)",
    fill: "#e1e1e1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_194",
    "data-name": "Trac\\xE9 194",
    d: "M4.286,0C6.652,0,8.572,2.592,8.572,5.784s-1.921,5.784-4.286,5.784S0,8.976,0,5.784,1.921,0,4.286,0Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_166",
    "data-name": "Groupe 166",
    transform: "translate(2410.028 -2050.432)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_146",
    "data-name": "Groupe 146",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_199",
    "data-name": "Trac\\xE9 199",
    d: "M42.749,10.331C33.635-4.926,8.15-2.076,2.126,11c-2.2,4.766-5.869,17.772,8.186,19.448,2.65.316,24.559.168,24.559.168s5.758-.338,8.527-4.733C45.483,22.574,45.994,15.764,42.749,10.331Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_200",
    "data-name": "Trac\\xE9 200",
    d: "M42.749,10.331C33.635-4.926,8.15-2.076,2.126,11c-2.2,4.766-5.869,17.772,8.186,19.448,2.65.316,24.559.168,24.559.168s5.758-.338,8.527-4.733C45.483,22.574,45.994,15.764,42.749,10.331Z",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_167",
    "data-name": "Groupe 167",
    transform: "translate(2417.754 -2039.313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_148",
    "data-name": "Groupe 148",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_201",
    "data-name": "Trac\\xE9 201",
    d: "M35,5.365v2.85a5.231,5.231,0,0,1-5.079,5.365H5.079A5.231,5.231,0,0,1,0,8.215V5.365A5.231,5.231,0,0,1,5.079,0h24.84A5.231,5.231,0,0,1,35,5.365Z",
    transform: "translate(0 0)",
    fill: "#222"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_202",
    "data-name": "Trac\\xE9 202",
    d: "M35,5.365v2.85a5.231,5.231,0,0,1-5.079,5.365H5.079A5.231,5.231,0,0,1,0,8.215V5.365A5.231,5.231,0,0,1,5.079,0h24.84A5.231,5.231,0,0,1,35,5.365Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeWidth: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_149",
    "data-name": "Groupe 149",
    transform: "translate(15.183 0.015)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_203",
    "data-name": "Trac\\xE9 203",
    d: "M5.715.046C5.608.509,6.217,8.869,0,13.4l15.793-.04s3.784.168,4.016-6.748c.116-3.477-1.1-6.5-4.46-6.581S5.715.087,5.715.046Z",
    transform: "translate(0 0)",
    fill: "#3a3a3a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_204",
    "data-name": "Trac\\xE9 204",
    d: "M5.715.046C5.608.509,6.217,8.869,0,13.4l15.793-.04s3.784.168,4.016-6.748c.116-3.477-1.1-6.5-4.46-6.581S5.715.087,5.715.046Z",
    transform: "translate(0 0)",
    fill: "rgba(0,0,0,0)",
    stroke: "#fff",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_168",
    "data-name": "Groupe 168",
    transform: "translate(2422.934 -2036.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_151",
    "data-name": "Groupe 151",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_205",
    "data-name": "Trac\\xE9 205",
    d: "M2.78,1.509V6.287A1.454,1.454,0,0,1,1.39,7.8h0A1.454,1.454,0,0,1,0,6.287V1.509A1.454,1.454,0,0,1,1.39,0h0A1.454,1.454,0,0,1,2.78,1.509Z",
    fill: "#fe8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_206",
    "data-name": "Trac\\xE9 206",
    d: "M2.78,1.509V6.287A1.454,1.454,0,0,1,1.39,7.8h0A1.454,1.454,0,0,1,0,6.287V1.509A1.454,1.454,0,0,1,1.39,0h0A1.454,1.454,0,0,1,2.78,1.509Z",
    fill: "#fe8045",
    stroke: "#fff",
    strokeWidth: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_169",
    "data-name": "Groupe 169",
    transform: "translate(2444.404 -2036.547)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_153",
    "data-name": "Groupe 153",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_207",
    "data-name": "Trac\\xE9 207",
    d: "M2.78,1.509V6.287A1.454,1.454,0,0,1,1.39,7.8h0A1.454,1.454,0,0,1,0,6.287V1.509A1.454,1.454,0,0,1,1.39,0h0A1.454,1.454,0,0,1,2.78,1.509Z",
    transform: "translate(0 0)",
    fill: "#fe8045"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_208",
    "data-name": "Trac\\xE9 208",
    d: "M2.78,1.509V6.287A1.454,1.454,0,0,1,1.39,7.8h0A1.454,1.454,0,0,1,0,6.287V1.509A1.454,1.454,0,0,1,1.39,0h0A1.454,1.454,0,0,1,2.78,1.509Z",
    transform: "translate(0 0)",
    fill: "#fe8045",
    stroke: "#fff",
    strokeWidth: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBotIcon);
export default __webpack_public_path__ + "static/media/bot-icon.ca3caddf1fc0366d5cc6c45aabe1a519.svg";
export { ForwardRef as ReactComponent };